import { useState } from 'preact/hooks';

// A label wrapping its input, so getByLabel(label) finds it.
export function Field({ label, hint, error, children }) {
  return (
    <label class="field">
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
      {error && <small class="field-error" role="alert">{error}</small>}
    </label>
  );
}

// Form state: bind('name') gives an input its value and onInput.
export function useForm(initial) {
  const [values, setValues] = useState(initial);
  const bind = (k) => ({ name: k, value: values[k], onInput: (e) => setValues((v) => ({ ...v, [k]: e.currentTarget.value })) });
  return [values, bind, setValues];
}
